(function () {
  'use strict';

  // Regular scent variant IDs ($14.99)

  const SCENT_IDS = [
    44291244654634, // Blue
    44291520299050, // Raw
    44291581050922, // Sea
    44291559030826, // Void
    44291589177386  // Noir
  ];

  // Add-on variant IDs ($9.99) — hidden products

  const ADDON_IDS = [
    44481135476778, // Blue Add-on
    44481135509546, // Raw Add-on
    44481161986090, // Sea Add-on
    44481135640618, // Void Add-on
    44481162051626  // Noir Add-on
  ];

  // All scent IDs combined for count

  const ALL_SCENT_IDS = [...SCENT_IDS, ...ADDON_IDS];


  async function getCart() {
    const r = await fetch('/cart.json', { cache: 'no-store' });
    return r.json();
  }

  async function addToCart(variantId) {
    const r = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 }),
    });
    if (!r.ok) throw new Error('Add to cart failed');
    return r.json();
  }

  function getScentCount(cart) {
    return cart.items
      .filter(i => ALL_SCENT_IDS.includes(i.variant_id))
      .reduce((s, i) => s + i.quantity, 0);
  }

  function updateCartCount(count) {
    const counter = document.querySelector('[data-testid="cart-bubble"]');
    if (counter) {
      counter.textContent = count;
      return;
    }
    const fallbacks = [
      '.cart-bubble__text-count',
      '.cart-count-bubble span[aria-hidden="true"]',
    ];
    for (const sel of fallbacks) {
      const el = document.querySelector(sel);
      if (el) { el.textContent = count; break; }
    }
  }

  const popup    = document.getElementById('trace-upsell-popup');
  const overlay  = document.getElementById('trace-popup-overlay');
  const closeBtn = document.getElementById('trace-popup-close');
  const skip1    = document.getElementById('trace-popup-skip-1');

  function openPopup() {
    if (!popup) return;
    popup.classList.add('trace-popup--open');
    popup.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closePopup() {
    if (!popup) return;
    popup.classList.remove('trace-popup--open');
    popup.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  if (overlay)  overlay.addEventListener('click', closePopup);
  if (closeBtn) closeBtn.addEventListener('click', closePopup);
  if (skip1)    skip1.addEventListener('click', closePopup);
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closePopup(); });

  document.querySelectorAll('.trace-btn--choose, .ts__btn-choose').forEach(btn => {
    btn.addEventListener('click', async function () {
      const variantId = parseInt(this.dataset.variantId);
      const original  = this.textContent.trim();

      this.innerHTML = '<span class="trace-spinner"></span>';
      this.disabled  = true;

      try {
        const cartBefore   = await getCart();
        const scentsBefore = getScentCount(cartBefore);

        await addToCart(variantId);

        const cartAfter = await getCart();
        updateCartCount(cartAfter.item_count);

        this.innerHTML = '✓ ADDED';
        this.classList.add('ts__btn-added');

        if (scentsBefore >= 1) {
          setTimeout(() => openPopup(), 500);
        }

        setTimeout(() => {
          this.textContent = original;
          this.disabled    = false;
          this.classList.remove('ts__btn-added');
        }, 2500);

      } catch (err) {
        console.error('Cart error:', err);
        this.textContent = original;
        this.disabled    = false;
      }
    });
  });

  document.querySelectorAll('.trace-popup__scent-btn').forEach(btn => {
    btn.addEventListener('click', async function () {
      const variantId = parseInt(this.dataset.variantId);
      const origHTML  = this.innerHTML;

      this.innerHTML = '<span class="trace-spinner trace-spinner--light"></span>';
      this.disabled  = true;

      try {
        await addToCart(variantId);

        const cart = await getCart();
        updateCartCount(cart.item_count);

        this.innerHTML = '✓ Added!';
        this.classList.add('trace-popup__scent-btn--done');

        setTimeout(() => {
          this.innerHTML = origHTML;
          this.disabled  = false;
          this.classList.remove('trace-popup__scent-btn--done');
        }, 1500);

      } catch (err) {
        console.error('Add-on cart error:', err);
        this.innerHTML = origHTML;
        this.disabled  = false;
      }
    });
  });

  document.querySelectorAll('a[href^="#"]').forEach(a => {
    a.addEventListener('click', function (e) {
      const t = document.querySelector(this.getAttribute('href'));
      if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth' }); }
    });
  });

  const style = document.createElement('style');
  style.textContent = `
    .ts__btn-added {
      background: #2d6a2d !important;
      border-color: #2d6a2d !important;
      color: #fff !important;
    }
    .trace-spinner {
      display: inline-block !important;
      width: 13px !important;
      height: 13px !important;
      border: 2px solid rgba(0,0,0,0.2) !important;
      border-top-color: #0a0a0a !important;
      border-radius: 50% !important;
      animation: trace-spin 0.6s linear infinite !important;
      vertical-align: middle !important;
    }
    .trace-spinner--light {
      border-color: rgba(255,255,255,0.2) !important;
      border-top-color: #fff !important;
    }
    @keyframes trace-spin { to { transform: rotate(360deg); } }
  `;
  document.head.appendChild(style);

})();